/**
 * Generic pill-style tabs with optional badge count.
 *
 * Usage:
 *   <PillTabs
 *     tabs={[
 *       { id: 'pending', label: 'En attente', count: 12 },
 *       { id: 'done',    label: 'Terminé',    count: 3  },
 *     ]}
 *     activeTab="pending"
 *     onChange={(tabId) => setActiveTab(tabId)}
 *   />
 */
const PillTabs = ({ tabs, activeTab, onChange }) => (
  <div className="flex gap-4 ft-sm">
    {tabs.map((tab) => (
      <div
        key={tab.id}
        className={`my-auto px-3 py-2 rounded cursor-pointer transition-colors ${
          activeTab === tab.id
            ? 'text-gray-700 bg-gray-100'
            : 'text-gray-500 hover:text-gray-600'
        }`}
        onClick={() => onChange(tab.id)}
      >
        <div className="flex gap-1 items-center">
          <span>{tab.label}</span>
          {tab.count !== undefined && (
            <span className="bg-yellow-100 text-yellow-800 rounded px-1 flex items-center justify-center min-w-[20px] text-xs font-medium">
              {tab.count}
            </span>
          )}
        </div>
      </div>
    ))}
  </div>
);

export default PillTabs;
